import { render } from "./virtualDataSetting.vue?vue&type=template&id=5b4da87e&scoped=true"
import script from "./virtualDataSetting.vue?vue&type=script&lang=js"
export * from "./virtualDataSetting.vue?vue&type=script&lang=js"

import "./virtualDataSetting.vue?vue&type=style&index=0&id=5b4da87e&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4da87e"]])

export default __exports__